import { View } from 'react-native';
const SafeAreaView = View;
export { SafeAreaView };
//# sourceMappingURL=SafeAreaView.web.js.map